import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "emb_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Authenticated axios instance for admin calls
export const authAxios = axios.create({ baseURL: API });
authAxios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---- Public ----
export const getContent = () => axios.get(`${API}/content`).then((r) => r.data);
export const submitQuote = (payload) => axios.post(`${API}/quotes`, payload).then((r) => r.data);
export const subscribe = (email) => axios.post(`${API}/subscribers`, { email }).then((r) => r.data);

// ---- Admin auth ----
export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);
export const adminMe = () => authAxios.get(`/admin/me`).then((r) => r.data);
export const adminChangePassword = (current_password, new_password) =>
  authAxios.post(`/admin/change-password`, { current_password, new_password }).then((r) => r.data);

// ---- Admin data ----
export const adminListQuotes = () => authAxios.get(`/quotes`).then((r) => r.data);
export const adminUpdateQuote = (id, handled) =>
  authAxios.patch(`/quotes/${id}`, { handled }).then((r) => r.data);
export const adminDeleteQuote = (id) => authAxios.delete(`/quotes/${id}`).then((r) => r.data);
export const adminListSubscribers = () => authAxios.get(`/subscribers`).then((r) => r.data);
export const adminExportSubscribersUrl = `${API}/subscribers/export`;
export const adminUpdateContent = (content) =>
  authAxios.put(`/admin/content`, { content }).then((r) => r.data);

// Map FastAPI error detail (string or 422 array) to a displayable message
export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
